import { FindEvaluationDonationsDto } from '../dtos/donations/find-evaluation-donations.dto';

export enum PermissionSection {
    DONATION_ENTRANCE = 'donator-entrance',
    DONATORS = 'donators',
    PROJECTS = 'projects',
    EVALUATION = 'evaluation',
    SETTINGS = 'settings',
    CHANNEL_IMPORT = 'channel-import',
    RECEIPTS = 'receipts',
    COLLECTION_LETTERS = 'collection-letters',
}

export interface User extends Document {
    /**
     * The unique id of the user
     */
    _id: string;
    /**
     * The authentication id of the user
     */
    authId: string;
    /**
     * The fcm client id of the user
     */
    fcmClientId: string;
    /**
     * Whether this user is archived
     */
    archived: boolean;
    /**
     * The company of the user
     */
    company: string;
    /**
     * The permissions of the user
     */
    permissions: PermissionSection[];
    /**
     * The evaluation filters of the user
     */
    evaluationFilters: EvaluationFilter[];

    /**
     * The creation timestamp when this user was created
     */
    createdAt: Date;
    /**
     * The timestamp when this user was last updated
     */
    updatedAt: Date;
}
export interface EvaluationFilter {
    /**
     * The unique id of the evaluation filter
     */
    _id: string;
    /**
     * The name of the evaluation filter
     */
    name: string;
    /**
     * The filter of the evaluation filter
     */
    filter: FindEvaluationDonationsDto;
}
